module.exports = __webpack_public_path__ + "img/c-en-18.8da22307.png";